// extracted by mini-css-extract-plugin
export default {"base":"NotificationBanner_base__sqczs"};